import styled from 'styled-components';

import Button from 'components/Buttons/Button';
import { FaRegCheckCircle } from 'react-icons/fa';

export const Container = styled.div`
  margin: 0 30px;
  padding-bottom: 30px;

  &:not(:last-child) {
    margin-bottom: 30px;
    border-bottom: solid 1px ${({ theme }) => theme.hotelDetails.separator};
  }
`;

export const Fare = styled.h5`
  font-size: 14px;
  margin-top: 10px;
  color: ${({ theme }) => theme.hotelDetails.strongGrey};
`;

export const Description = styled.li`
  font-size: 14px;
  margin-top: 10px;
  list-style-type: disc;
  color: ${({ theme }) => theme.hotelDetails.strongGrey};
`;

export const Footer = styled.div`
  display: flex;
  align-items: flex-end;
  margin-top: 22px;
`;

export const Selection = styled(Button)`
  width: 150px;
  height: 56px;
  margin-top: 10px;
  margin-left: auto;
`;

export const ContentRefundableItems = styled.div`
  display: flex;
  margin-top: 10px;
`;

export const Tag = styled.div`
  margin-top: 16px;
  padding-right: 5px;
`;
export const PayAtDestination = styled.div`
  height: 20%;
  display: flex;
  align-items: center;
`;

export const PayAtDestinationText = styled.div`
  font-size: 14px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  width: 200px;
  color: ${({ theme }) => theme.dataCardHotels.cleanColor};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-right: 8px;
`;

export const CheckCircleIcon = styled(FaRegCheckCircle)`
  font-size: 14px;
  color: ${({ theme }) => theme.dataCardHotels.cleanColor} !important;
  margin-top: 4px;
  margin-right: 4px;
  @media (min-width: 446px) {
    align-self: center;
    margin-top: 0;
  }
`